import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/Account`;

function paramsToStringList(params) {
  let stringparams = "?";
  Object.entries(params).map(([key, value]) => {
      if (value != undefined && value != null)
          stringparams = stringparams + key + "=" + value + "&";
  })
  stringparams = stringparams.substr(0, stringparams.length - 1);
  return stringparams;
}

const ApiAuth = {
    loginByMobile: (data) => {
        console.log(data);
        try {
            const url = `${baseServiceUrl}/requestAuthenticateByPhoneAsync`;
            var result = ServiceApi.post(url, data);
            console.log("result====", result);
        }
        catch (error) {
            alert(error.response.data.message);
        }
        return result
    },
    verifyMobile: (data) => {
        console.log(data);
        const url = `${baseServiceUrl}/authenticateByPhone`;
        var result = ServiceApi.post(url, data);
        console.log("result====", result);
        return result
    },
  login: (params) => {
    console.log("params==========", params);
    const url = `${baseServiceUrl}/authenticate`;
    console.log("url==========", url);
    return ServiceApi.post(url, params);
  },
  logout: (params) => {
    console.log("params==========", params);
    const url = `${baseServiceUrl}/logout` + paramsToStringList(params);
    console.log("url==========", url);
    return ServiceApi.post(url);
  },
    register: (params) => {
        console.log("params==========", params);
        const url = `${baseServiceUrl}/register`;
        console.log("url==========", url);
        return ServiceApi.post(url, params);
    },
    forgotPassword: (params) => {
        console.log("params==========", params);
        const url = `${baseServiceUrl}/forgotPassword`;
        console.log("url==========", url);
        return ServiceApi.post(url, params);
    },
    changePassword: (params) => {
        console.log("params==========", params);
        const url = `${baseServiceUrl}/changePassword`;
        console.log("url==========", url);
        return ServiceApi.post(url, params);
    },
};

export default ApiAuth;
